/**
 * Indicador visual mínimo de carga.
 *
 * Se usa en dashboards mientras llegan datos asíncronos desde Firebase.
 */
import React from "react";
import "./Loader.scss";

const Loader = () => {
  return (
    <div className="loader">
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;
